import type { Currency, Tier } from "@mw/shared/pricing";
import type { Locale } from "@mw/shared/i18n";
import { getPriceForCurrency } from "@mw/shared/pricing";
import { formatPrice } from "@utilities/numbers";
import type { StaticImageData } from "next/image";

import FreeCover from "./covers/Free.png";
import StarterCover from "./covers/Starter.png";
import CreatorCover from "./covers/Creator.png";
import ProCover from "./covers/Pro.png";
import BusinessCover from "./covers/Business.png";
import ScaleCover from "./covers/Scale.png";
import EnterpriseCover from "./covers/Enterprise.png";

export function setStarterTierPromotion(tiers: Tier[]) {
  const starterTier = tiers.find(tier => tier.planId === "starter");
  if (starterTier?.pricing?.subscription?.monthly) {
    starterTier.pricing.subscription.monthly.discountedPrice = 1;
    starterTier.pricing.subscription.monthly.discountMessageKey = "first_month_one_dollar";
  }
}

export function getPrices(pricing: Tier["pricing"], period: "monthly" | "yearly") {
  const defaultPricing = { price: undefined, discountedPrice: undefined, discountMessageKey: undefined };
  const subscription = pricing?.subscription;
  if (period === "yearly" && subscription?.yearly) {
    return { ...defaultPricing, ...subscription.yearly };
  }
  if (period === "monthly" && subscription?.monthly) {
    return { ...defaultPricing, ...subscription.monthly };
  }
  return defaultPricing;
}

export function getFormattedPrices(
  tier: Tier["pricing"],
  period: "monthly" | "yearly",
  currency: Currency,
  currencySymbol: string,
  locale: Locale,
) {
  const { price, discountedPrice, discountMessageKey } = getPrices(tier, period);
  const displayedPrice = discountedPrice ?? price ?? undefined;
  const convertedDisplayedPrice =
    displayedPrice !== undefined ? getPriceForCurrency(displayedPrice, currency) : undefined;
  const convertedOriginalPrice = price !== undefined ? getPriceForCurrency(price, currency) : undefined;
  const currencyFormattedPrice =
    convertedDisplayedPrice !== undefined ? formatPrice(convertedDisplayedPrice, currencySymbol, locale) : "";
  const formattedOriginalPrice =
    convertedOriginalPrice !== undefined ? formatPrice(convertedOriginalPrice, currencySymbol, locale) : "";

  return {
    price,
    discountedPrice,
    discountMessageKey,
    convertedOriginalPrice,
    currencyFormattedPrice,
    formattedOriginalPrice,
  };
}

export const TIER_COVER_IMAGES: Record<string, StaticImageData> = {
  free: FreeCover,
  starter: StarterCover,
  creator: CreatorCover,
  pro: ProCover,
  business: BusinessCover,
  scale: ScaleCover,
  scale_2024_08_10: BusinessCover,
  enterprise: EnterpriseCover,
  payg: FreeCover,
};
